<template>
  <area-select
    size="small"
    type="code"
    :level="2"
    :value="selected"
    icon="direction-right-icon"
    :data="pcaa"
    @change="areaChange"
  />
</template>

<script>
import { pcaa } from "area-data";

export default {
  props: {
    selectedArr: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selected() {
      return this.selectedArr;
    }
  },
  data() {
    return {
      pcaa: pcaa
    };
  },
  methods: {
    areaChange(value) {
      this.$emit("areaHandle", value);
    },
    clearValue() {
      document.querySelectorAll(
        ".area-selected-trigger"
      )[0].innerText = this.$t("placeholder.select");
      document.querySelectorAll(
        ".area-selected-trigger"
      )[1].innerText = this.$t("placeholder.select");
      document.querySelectorAll(
        ".area-selected-trigger"
      )[2].innerText = this.$t("placeholder.select");
    }
  },
  mounted() {
    document.querySelectorAll(".area-selected-trigger")[0].innerText = this.$t(
      "placeholder.select"
    );
    document.querySelectorAll(".area-selected-trigger")[1].innerText = this.$t(
      "placeholder.select"
    );
    document.querySelectorAll(".area-selected-trigger")[2].innerText = this.$t(
      "placeholder.select"
    );
  }
};
</script>

<style lang="scss">
.area-select-wrap {
  .area-select {
    height: 32px;
    line-height: 32px;
    .area-selected-trigger {
      padding: 5px 20px 0 12px;
      color: $globalFontSizeColor;
    }
  }
  .area-select .area-select-icon.active {
    transform: rotate(90deg);
  }
  .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select-icon {
    margin-top: -7px;
    width: 14px;
    height: 14px;
    content: none;
    border: none;
    background: url("~@/assets/img/cmb_direction_right.png") no-repeat center;
  }
  .area-selectable-list .area-select-option.selected {
    background-color: $globalBGColor;
    color: #fff;
  }
}
</style>
